// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global styles for TwentyTwentysix redesign only.
 * Import inside TwentyTwentysixSiteApp so they don't affect the rest of the site.
 */
/* Optional: scope all twentytwentysix styles under a wrapper class if needed */
.twentytwentysix-site {
  font-family: var(--twentytwentysix-font-family);
  color: var(--twentytwentysix-color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/globals.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,+EAA+E;AAC/E;EACE,+CAA+C;EAC/C,wCAAwC;EACxC,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["/**\n * Global styles for TwentyTwentysix redesign only.\n * Import inside TwentyTwentysixSiteApp so they don't affect the rest of the site.\n */\n/* Optional: scope all twentytwentysix styles under a wrapper class if needed */\n.twentytwentysix-site {\n  font-family: var(--twentytwentysix-font-family);\n  color: var(--twentytwentysix-color-text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
